export interface PrequalificationReportRule {
  code: string;
  name: string;
  description: string;
  periods: number;
  result: [];
}
